import { Component, OnInit } from '@angular/core'
import { HttpClient } from '@angular/common/http'

@Component({
    selector: 'app-home-index',
    templateUrl: './Index.html',
    styleUrls: []
})
export class HomeIndexComponent implements OnInit {
    ngOnInit(): void {  }
    constructor(private http: HttpClient) { }
}